<template>
    <b-row class="justify-content-center">
        <!-- BOUTONS DE SELECTION DISTRIBUTEUR -->
        <b-col
            v-for="(form, index) in Forms"
            :key="index"
            class="d-flex mb-3"
            cols="12"
            sm="6"
            lg="3">
            <b-button
                @click="initCertificate(form.Type)"
                class="distributor-button h-100 w-100 position-relative"
                :pressed="form.Type == certificate.Distributor"
                :disabled="form.RequiresContract && !hasContract(form)"
                :variant="form.Type == certificate.Distributor ? Variant + '-light bg-white' : 'gray-light bg-white'">
                <b-icon-check-circle-fill
                    v-if="form.Type == certificate.Distributor"
                    :variant="Variant"
                    class="selection-icon"/>
                <b-icon-circle
                    v-else
                    :variant="Variant"
                    class="selection-icon"/>
                <b-img
                    :src="getLogo(form.Name)"
                    :width="300"
                    alt="Logo"
                    class="distributor-logo"
                    v-b-tooltip.html
                    :title="isContractMissing(form) ? $t('ContractRequiredForCertificate') : form.Name"/>
            </b-button>
        </b-col>
    </b-row>
</template>
<script lang="ts">

    /**
     * Composants Vue js
     */
    import { Component, InjectReactive, Prop, PropSync, Vue } from 'vue-property-decorator';
    import { Getter } from 'vuex-class';

    /**
     * Classes et énumérations
     */
    import { SMACertificate } from '@/types/Administration/SMA/SMACertificate';
    import { SMAContract, SMADistributorForm } from '@/types/Administration/SMA/SMADistributorForm';

    /**
     * Traductions
     */
    import locale from '../../locales/SMA.json';
    
	@Component({
        i18n: {messages:locale}
	})
    /**
     * Formulaire de selection distributeur
     */
	export default class DistributorForm extends Vue {
    
        /**
         * Mandat
         */
        @PropSync('Certificate', { default: () => {} })
        public certificate!: SMACertificate;

        /**
         * Formulaires distributeurs
         */
        @Prop()
        public Forms!: Array<SMADistributorForm>;

        /**
         * Mode
         */
        @Prop()
        public Mode!: "New" | "Edit";

        /** 
         * Variant de couleur à appliquer sur le composant 
         */
        @InjectReactive()
        public Variant!: string;

        /**
         * Liste des contrats (AKEA et clients) chargés dans le store
         */
        @Getter('CertificateStore/GetContracts')
        public contracts!: Array<SMAContract>;

        /**
         * Initialisation du mandat lors de la selection du distributeur
         * @param value Identifiant distributeur
         */
        private initCertificate(value: number) : void
        {
            this.certificate = new SMACertificate({ CertificateId: "0", CertificateName: "", Distributor: value });
        }

        /**
         * Retourne l'url du logo du distributeur : en svg si disponible, sinon en webp
         * @param name Nom du distributeur
         */
        private getLogo(name: string) : string
        {
            try
            {
                return require(`@/assets/images/${name}.svg`);
            }
            catch
            {
                return require(`@/assets/images/${name}.webp`);
            }
        }

        /**
         * Indique si au moins un contrat du type requis existe pour le distributeur
         * (types déclarés dans SMAAttribute : contrat AKEA et/ou contrat client)
         * @param form Formulaire distributeur
         */
        private hasContract(form: SMADistributorForm) : boolean
        {
            const requiredTypes = form.RequiredContractTypes;
            return this.contracts.some(contract => contract.Type == form.Type
                && (!requiredTypes || requiredTypes.length === 0 || requiredTypes.includes(contract.ContractType)));
        }

        /**
         * Indique si le distributeur requiert un contrat et qu'aucun contrat n'existe
         * @param form Formulaire distributeur
         */
        private isContractMissing(form: SMADistributorForm) : boolean
        {
            return form.RequiresContract && !this.hasContract(form);
        }
    }
    
</script>
<style scoped>
    /**
     * Icône de sélection positionnée dans le coin haut droit du bouton
     */
    .selection-icon {
        position: absolute;
        top: 5px;
        right: 5px;
    }

    /**
     * Logo du distributeur : s'adapte à la largeur du bouton
     */
    .distributor-logo {
        max-width: 100%;
    }
</style>